/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![DoubleCheckmarkIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA8klEQVR4nO2SOw6CQBCGKSy1MPF5BS9Ba4SdHYrNjI8LeQrPoYmFlRY2KFFPo2YM6wOJisTG8FdkmP2+/LCOU6TI/6ZrTB00TwFp/BO4QtoA8kkkdu77/VpuaRCMGjc47XvGtKwUkMKkNFMAoAJIUQzZCvSpEVIoTZ4PI43FnPoyDoDpAPJRJNLkY/jlsKZZ2hIgTxTywgJFYowpy7PMpMlbuMTzBlWFtJZlpXlnvy1omseASClu2v1M8FcS736GfAiCYfsr+MNVs7cBKRRBYhZdf3RWeJpEIfnJdrngNjHQd123dC9WSCvQvMwFL1LEyZIzS6GrKZfuh5kAAAAASUVORK5CYII=)
 */
export const DoubleCheckmarkIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.7 8.7a1 1 0 0 0-1.4-1.4l-3.26 3.24a1 1 0 0 0 1.42 1.42L16.7 8.7ZM3.7 11.3a1 1 0 0 0-1.4 1.4l4.5 4.5a1 1 0 0 0 1.4-1.4l-4.5-4.5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 9.7a1 1 0 0 0-1.4-1.4L13 15.58l-3.3-3.3a1 1 0 0 0-1.4 1.42l4 4a1 1 0 0 0 1.4 0l8-8Z"
        className={colorClass}
      />
    </svg>
  );
};
